import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";
// import SelectSearch from 'react-select-search'
import SelectSearch, { components, InputActionMeta } from "react-select";
import { Typeahead } from "react-bootstrap-typeahead";

import { FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import apiInstance from "../../../../Utils/api";
import BASE_API_URL from "../../../../api/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const [inputText, setInputText] = useState("");

  // const handleInputChange = (inputText: string, meta: InputActionMeta) => {
  //   if (meta.action !== 'input-blur' && meta.action !== 'menu-close') {
  //     setInputText(inputText)
  //   }
  // }

  const [doctors, setDoctors] = useState([]);
  const [tName, setTName] = useState([]);
  const [therapists, setTherapists] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [isMedicineProduct, setIsMedicineProduct] = useState(false);
  const [isAccItem, setIsAccItem] = useState(false);

  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [qty, setQty] = useState("");

  const [macid, setMacId] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState("");

  const [percent, setPercent] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [generalList, setGeneralList] = useState([]);
  const [isGenItem, setIsGenItem] = useState(false);
  const [generalSelection, setGeneralSelection] = useState([]);
  //Gen
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });
  const customFilter = (option, searchText) => {
    if (
      option.data.first_name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.last_name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.gender.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const [sellPrice, setSellPrice] = useState("");

  const [description, setDescription] = useState("");
  const [doctorname, setDoctorName] = useState("");
  const [therapistname, setTherapistName] = useState("");
  const [treatmenttime, setTreatmentTime] = useState("");
  const [treatmentCode, setTreatmentCode] = useState("");
  const [name, setName] = useState("");

  const [medSelection, setMedSelection] = useState([]);
  const [proMedSelection, setProMedSelection] = useState([]);
  const [accSelection, setAccSelection] = useState([]);

  const [machineSelection, setMachineSelection] = useState([]);

  // console.log(selection, 'sel')

  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Pro Acc
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });

  //Machine
  const [tableMachineData, setTableMachineData] = useState([]);
  const [selectMacOption, setSelectMacOption] = useState({
    id: "",
    name: "",
  });

  // const name = useLocation().pathname.split('/')[3]

  const Id = useLocation().pathname.split("/")[2];

  useEffect(() => {
    const getDoctors = async () => {
      const res = await apiInstance.get("doctors");
      setDoctors(res.data.data);
    };
    const getTherapists = async () => {
      const res = await apiInstance.get("therapists");
      setTherapists(res.data.data);
    };
    const getMedicine = async () => {
      const res = await apiInstance.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await apiInstance.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await apiInstance.get("accessory-items");
      console.log(res.data.list);
      setAccessories(res.data.list);
    };
    const getGeneral = async () => {
      const res = await apiInstance.get("general-items");
      console.log(res.data.list);
      setGeneralList(res.data.list);
    };
    const getTreatment = async () => {
      const res = await apiInstance.get("treatment-list/" + Id);
      console.log(res.data.data[0]);

      setTName(res.data.data[0].name);
      console.log(res.data.data[0].name);
    };

    const getMachines = async () => {
      const res = await apiInstance.get("fixed-assets");
      setMachines(
        res.data.list.filter(
          (el) =>
            el.type == "Medical Equipment" ||
            el.type == "Surgery Equipment" ||
            el.type == "Medical Machinery",
        ),
      );
    };

    const getBranches = async () => {
      const res = await apiInstance.get("branches");
      setBranchList(res.data.list);
      console.log(
        res.data.list.map((i) => i._id),
        "b id",
      );
    };

    getBranches();
    getTreatment();
    getGeneral();
    getMedicine();
    getDoctors();
    getTherapists();
    getProcedures();
    getAccessories();
    getMachines();
  }, []);

  const handleSelect = (val) => {
    this.setState({ selected: val });
  };
  const filteredOptions = medicineList.filter((option) =>
    option.medicineItemName.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const handleSearchChange = (event) => {
    console.log(event, "ite");
    if (event !== null) {
      const SearchMedItem = medicineList.filter((option) =>
        option.medicineItemName.toLowerCase().includes(event.toLowerCase()),
      );
      console.log(
        medicineList.filter((option) =>
          option.medicineItemName.toLowerCase().includes(event.toLowerCase()),
        ),
        "res",
      );
      setMedicineList(SearchMedItem);
    } else {
      setMedicineList(medicineList);
    }
  };

  // const handleBranch = id => {
  //   setBranch(id)
  //   if (id == '6474394fdab649311f9fcc32') {
  //     setBranchName('SOK')
  //   } else {
  //     setBranchName(branchList.filter(el => el._id === id)[0].name)
  //   }

  //   if (id == '6474394fdab649311f9fcc32') {
  //     setShowEight(false)
  //     setShowHO(true)
  //     setShowPrice(false)
  //     setShowLSH(false)
  //     setShowNPT(false)
  //     setShowMDY(false)
  //     setShowK(false)
  //   }
  //   if (id == '64743985dab649311f9fcc33') {
  //     setShowEight(true)
  //     setShowHO(false)
  //     setShowPrice(false)
  //     setShowLSH(false)
  //     setShowNPT(false)
  //     setShowMDY(false)
  //     setShowK(false)
  //   }
  //   if (id == '64743991dab649311f9fcc34') {
  //     setShowEight(false)
  //     setShowHO(false)
  //     setShowPrice(false)
  //     setShowLSH(false)
  //     setShowNPT(true)
  //     setShowMDY(false)
  //     setShowK(false)
  //   }
  //   if (id == '6474399edab649311f9fcc35') {
  //     setShowEight(false)
  //     setShowHO(false)
  //     setShowPrice(false)
  //     setShowLSH(true)
  //     setShowNPT(false)
  //     setShowMDY(false)
  //     setShowK(false)
  //   }
  //   if (id == '647439aadab649311f9fcc36') {
  //     setShowEight(false)
  //     setShowHO(false)
  //     setShowPrice(false)
  //     setShowLSH(false)
  //     setShowNPT(false)
  //     setShowMDY(true)
  //     setShowK(false)
  //   }
  //   if (id == '649559535fc22f0e7f0884fe') {
  //     setShowEight(false)
  //     setShowHO(false)
  //     setShowPrice(true)
  //     setShowLSH(false)
  //     setShowNPT(false)
  //     setShowMDY(false)
  //     setShowK(false)
  //   }
  //   if (id == '64b6064a61cdd336e64f9300') {
  //     setShowEight(false)
  //     setShowHO(false)
  //     setShowPrice(false)
  //     setShowLSH(false)
  //     setShowNPT(false)
  //     setShowMDY(false)
  //     setShowK(true)
  //   }
  // }

  const handleSearchItem = (val) => {
    console.log("search");
  };

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const newData = tableProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableProData([
      ...tableProData,
      {
        id: tableProData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsItem(true);
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (id) => {
    setTableProData(tableProData.filter((el) => el.id !== id));
  };
  //General
  const handleGeneralInputChange = (event, id, field) => {
    const newData = tableGenData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableGenData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleGeneralAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableGenData([
      ...tableGenData,
      {
        id: tableGenData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsGenItem(true);
  };

  //NOTE to get Id and Name of procedure medicine

  //NOTE to delete proecedure medicine
  const removeGeneral = (id) => {
    // console.log(id, 'gen')
    setTableGenData(tableGenData.filter((el, i) => el.id !== id));
  };
  //End procedure medicine add row

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleMachineInputChange = (event, id, field) => {
    const newData = tableMachineData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    // console.log(newData)
    setTableMachineData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMachineAddRow = (id, name) => {
    console.log(name, "Mac name");
    setTableMachineData([
      ...tableMachineData,
      {
        id: tableMachineData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMacItem(true);
  };

  //NOTE to delete proecedure medicine
  const removeMac = (id) => {
    // console.log(id, 'Re Id')
    setTableMachineData(tableMachineData.filter((el) => el.id != id));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty
  const handleMedInputChange = (event, id, field) => {
    const newData = tableMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableMedData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleMedAddRow = (id, name) => {
    // console.log(name, 'Med name')
    setTableMedData([
      ...tableMedData,
      {
        id: tableMedData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMedItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMedGet = (event) => {
    console.log(event, "ev");
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const medName = selectedOption.getAttribute("data-name");
    setSelectMedOption({
      id: id,
      name: medName,
    });

    // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', medName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (id) => {
    setTableMedData(tableMedData.filter((el) => el.id != id));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const newData = tableProAccData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProAccData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAccAddRow = (id, name) => {
    // console.log(name, 'proAcc name')
    setTableProAccData([
      ...tableProAccData,
      {
        id: tableProAccData.length + 1,
        name: name,
        item_id: id,
        quantity: "",
        perUsageQTY: "",
        unit: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsAccItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProAccGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proAccName = selectedOption.getAttribute("data-name");
    setSelectProAccOption({
      id: id,
      name: proAccName,
    });

    const value = event.target.value;
    // Use the id, name, and value as needed
    console.log("ID:", id);
    console.log("Name:", proAccName);
    console.log("Value:", value);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (id) => {
    setTableProAccData(tableProAccData.filter((el) => el.id !== id));
  };

  const handlePercent = (event) => {
    setPercent(event);
    const res = (event / 100) * totalPrice;
    const final = totalPrice - res;

    setSellPrice(final);
    // console.log((event / 100) * totalPrice, 'per res')
  };
  //End Medicine add row

  //End add table row and delete
  const create = () => {
    const data = {
      treatmentCode: treatmentCode,
      name: name,
      treatmentName: Id,
      treatmentTimes: treatmenttime,
      isMedicineProduct: isMedicineProduct,
      // relatedDoctor: doctorname,
      medicineLists: tableMedData,
      procedureMedicine: tableProData,
      procedureAccessory: tableProAccData,
      general: tableGenData,
      machine: tableMachineData,
      // estimateTotalPrice: totalPrice,
      discount: percent,
      // sellingPrice: sellPrice,
      // TCLEstimateTotalPrice: TCLtotalPrice,
      // TCLSellingPrice: TCLSellPrice,
      description: description,
      status: true,
    };

    if (totalPrice && sellPrice) {
      data.estimateTotalPrice = parseInt(totalPrice);
      data.TamweEstimateTotalPrice = parseInt(totalPrice);
      data.MDYEstimateTotalPrice = parseInt(totalPrice);
      data.LSHEstimateTotalPrice = parseInt(totalPrice);
      data.EightMileEstimateTotalPrice = parseInt(totalPrice);
      data.NPTEstimateTotalPrice = parseInt(totalPrice);
      data.SanChaungEstimateTotalPrice = parseInt(totalPrice);
      data.ThingangyunEstimateTotalPrice = parseInt(totalPrice);
      data.TCLEstimateTotalPrice = parseInt(totalPrice);
      data.KShoppingEstimateTotalPrice = parseInt(totalPrice);
      data.LMDEstimateTotalPrice = parseInt(totalPrice);

      data.sellingPrice = sellPrice;
      data.TamweSellingPrice = sellPrice;
      data.MDYSellingPrice = sellPrice;
      data.LSHSellingPrice = sellPrice;
      data.EightMileSellingPrice = sellPrice;
      data.NPTSellingPrice = sellPrice;
      data.SanChaungSellingPrice = sellPrice;
      data.ThingangyunSellingPrice = sellPrice;

      data.TCLSellingPrice = sellPrice;
      data.KShoppingSellingPrice = sellPrice;
      data.LMDSellingPrice = sellPrice;

      data.discount = percent;
    }

    // alert(JSON.stringify(data))

    apiInstance
      .post("treatment", data)
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "Successfully Created",
          icon: "success",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };
  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={"/checkUnit/" + Id}>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Treatment Create</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark">
                <h5>{tName}'s Unit Create</h5>
                <div className="offset-2 col-8 py-5">
                  <div className="row">
                    <div className="col-4 form-group ">
                      <Label>
                        Treatment Unit Name<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group">
                      <Label>
                        Treatment Unit Code<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        onChange={(e) => setTreatmentCode(e.target.value)}
                      />
                    </div>
                    <div className="col-4 form-group">
                      <Label>Treatment Times</Label>
                      <Input
                        type="number"
                        className="form-control"
                        onChange={(e) => setTreatmentTime(e.target.value)}
                      />
                    </div>
                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Doctor Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setDoctorName(e.target.value)}
                      >
                        <Option>Select Doctor</Option>
                        {doctors.map((doctor, i) => (
                          <Option value={doctor._id}>{doctor.name}</Option>
                        ))}
                      </Select>
                    </div> */}
                    {/* <div className='col-4 form-group mt-3'>
                      <Label>
                        Therapist Name<Span>*</Span>
                      </Label>
                      <Select
                        className='form-control'
                        onChange={e => setTherapistName(e.target.value)}
                      >
                        <Option>Select Therapist</Option>
                        {therapists.map((therapist, i) => (
                          <Option value={therapist._id}>
                            {therapist.name}
                          </Option>
                        ))}
                      </Select>
                    </div> */}
                    <div className="col-6 form-group mt-3">
                      <Label>Medicine</Label>

                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="medicineItemName"
                        onChange={setMedSelection}
                        options={medicineList}
                        placeholder="Choose a medicine items..."
                        selected={medSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMedAddRow(
                            medSelection[0]._id,
                            medSelection[0].medicineItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>

                            <Th>Per Usage Qty</Th>

                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isMedItem && (
                          <Tbody>
                            {tableMedData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeMedicine(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE Procedure Medicine */}
                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Medicine</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="procedureItemName"
                        onChange={setProMedSelection}
                        options={procedures}
                        placeholder="Choose a procedure items..."
                        selected={proMedSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAddRow(
                            proMedSelection[0]._id,
                            proMedSelection[0].procedureItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-4">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            {/* <Th>Amount</Th> */}
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isItem && (
                          <Tbody>
                            {tableProData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <RxCross2
                                    onClick={(e) => removeProcedure(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>
                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>Procedure Accessory</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="accessoryItemName"
                        onChange={setAccSelection}
                        options={accessories}
                        placeholder="Choose a state accessory items..."
                        selected={accSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleProAccAddRow(
                            accSelection[0]._id,
                            accSelection[0].accessoryItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isAccItem && (
                          <Tbody>
                            {tableProAccData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE End Procedure Medicine */}

                    <div className="col-6 form-group mt-3">
                      <Label>General Items</Label>
                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="accessoryItemName"
                        onChange={setGeneralSelection}
                        options={generalList}
                        placeholder="Choose a state accessory items..."
                        selected={generalSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleGeneralAddRow(
                            generalSelection[0]._id,
                            generalSelection[0].accessoryItemName ||
                              generalSelection[0].generalItemName,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>
                            {/* <Th>Purchase Price</Th> */}
                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isGenItem && (
                          <Tbody>
                            {tableGenData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleGeneralInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <RxCross2
                                    onClick={() => removeGeneral(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* NOTE End Procedure Accessory */}

                    <div className="col-6 form-group mt-3">
                      <Label>Machine</Label>

                      <Typeahead
                        id="basic-typeahead-single"
                        labelKey="name"
                        onChange={setMachineSelection}
                        options={machines}
                        placeholder="Choose a machine items..."
                        selected={machineSelection}
                      />
                    </div>
                    <div className="col-3 mt-4">
                      <Button
                        onClick={(e) =>
                          handleMachineAddRow(
                            machineSelection[0]._id,
                            machineSelection[0].name,
                          )
                        }
                      >
                        Add
                      </Button>
                    </div>
                    <div className="col-12 mt-3">
                      <Table className="table table-striped">
                        <Thead>
                          <Tr>
                            <Th>No.</Th>
                            <Th>Item Name</Th>
                            <Th>Qty</Th>

                            <Th>Per Usage Qty</Th>
                            <Th>Unit</Th>
                          </Tr>
                        </Thead>
                        {isMacItem && (
                          <Tbody>
                            {tableMachineData.map((item, index) => (
                              <Tr>
                                <Td>{++index}</Td>
                                <Td>{item.name}</Td>
                                <Td>
                                  <input
                                    type="number"
                                    // defaultValue={procedure.qty}
                                    defaultValue={item.quantity}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "quantity",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>

                                <Td>
                                  <input
                                    type="number"
                                    defaultValue={item.perUsageQTY}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "perUsageQTY",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>
                                <Td>
                                  <input
                                    type="text"
                                    defaultValue={item.unit}
                                    onChange={(event) =>
                                      handleMachineInputChange(
                                        event,
                                        item.id,
                                        "unit",
                                      )
                                    }
                                    className=" form-control"
                                  />
                                </Td>

                                <Td>
                                  <RxCross2
                                    onClick={() => removeMac(item.id)}
                                  />
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        )}
                      </Table>
                    </div>

                    {/* <div class='form-group'>
                      <label for='name'>Branch</label>
                      <select
                        class='custom-select border-info'
                        name='account_type_id'
                        onChange={e => handleBranch(e.target.value)}
                      >
                        <option hidden>Select Branch</option>

                        {branchList.map(option => (
                          <option value={option._id}>{option.name}</option>
                        ))}
                      </select>
                    </div> */}

                    <div className="row">
                      <div className="col-4 form-group mt-3">
                        <Label>Original Price</Label>
                        <Input
                          type="number"
                          className="form-control"
                          onChange={(e) => setTotalPrice(e.target.value)}
                        />
                      </div>
                      <div className="col-2 form-group mt-3">
                        <Label>Percent(%)</Label>
                        <Input
                          type="number"
                          className="form-control"
                          onChange={(e) => handlePercent(e.target.value)}
                        />
                      </div>
                      <div className="col-4 form-group mt-3">
                        <Label>Selling Price</Label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Thai Baht"
                            value={sellPrice}
                          />
                          <div className="input" style={{ marginTop: "0.5em" }}>
                            <span className="input-group-text">THB</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* {showPrice && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>TCL Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setTCLTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>TCL Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setTCLSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showEight && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>8Mile Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setEightTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>8Mile Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setEightSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showNPT && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>NPT Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setNptTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>NPT Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setNptSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showMDY && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>MDY Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setMDYTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>MDY Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setMDYSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showLSH && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>LSH Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setLSHTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>LSH Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setLSHSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )}
                    {showK && (
                      <div className='row'>
                        <div className='col-4 form-group mt-3'>
                          <Label>K Total Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setKTotalPrice(e.target.value)}
                          />
                        </div>

                        <div className='col-4 form-group mt-3'>
                          <Label>K Selling Price</Label>
                          <Input
                            type='number'
                            className='form-control'
                            onChange={e => setKSellPrice(e.target.value)}
                          />
                        </div>
                      </div>
                    )} */}

                    <div className="col-6 form-group mt-3">
                      <Label>Description</Label>
                      <Textarea
                        className="form-control"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </div>
                    <div className="col-6 form-group mt-5">
                      <div className="row">
                        <div className="col-5">
                          <span className="text-lg font-weight-bold">
                            IsMedicineProduct ?{" "}
                          </span>
                        </div>
                      </div>

                      <div className="col-5">
                        <input
                          type="checkbox"
                          className="h-50 mt-3"
                          onChange={() =>
                            setIsMedicineProduct(!isMedicineProduct)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <Top>
                  <Center>
                    <Button onClick={create}>Save</Button>
                  </Center>
                </Top>
              </div>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
